// src/components/strumenti/ConversioneUnita.js — W442. Lunghezze, superfici, volumi, masse
import React from "react";
import { useCampi, Campo, Scelta, Griglia, Risultato, Formula, Azzera, fmt } from "./UiStrumento";
import { UNITA, convertiUnita } from "../../utils/calcoliStrumenti";

const INIZIO = { lunghezza:["m","cm"], superficie:["m²","ettaro (ha)"], volume:["m³","litro (dm³)"], massa:["kg","quintale (q)"] };

export default function ConversioneUnita() {
  const { v, set, n, azzera, setV } = useCampi({ grandezza:"lunghezza", valore:"", da:"m", a:"cm" });
  const unita = Object.keys(UNITA[v.grandezza].unita);
  const r = convertiUnita(n("valore"), v.grandezza, v.da, v.a);
  const cambiaGrandezza = (e) => { const g = e.target.value; setV(o => ({ ...o, grandezza:g, da:INIZIO[g][0], a:INIZIO[g][1] })); };
  return (
    <div>
      <Griglia colonne={2}>
        <Scelta etichetta="Grandezza" valore={v.grandezza} onChange={cambiaGrandezza} opzioni={[["lunghezza","Lunghezza"],["superficie","Superficie"],["volume","Volume"],["massa","Massa"]]}/>
        <Campo etichetta="Valore" valore={v.valore} onChange={set("valore")} placeholder="Es. 12,5"/>
      </Griglia>
      <Griglia colonne={2}>
        <Scelta etichetta="Da" valore={v.da} onChange={set("da")} opzioni={unita}/>
        <Scelta etichetta="A" valore={v.a} onChange={set("a")} opzioni={unita}/>
      </Griglia>
      <Risultato settore="matematica" titolo="Risultato" valore={fmt(r, 6)} unita={v.a}/>
      <Formula>Valore × (fattore dell'unità di partenza ÷ fattore dell'unità di arrivo), con fattori esatti verso m, m², m³ e kg (1 in = 2,54 cm; 1 ft = 30,48 cm; 1 lb = 0,45359237 kg; 1 gallone USA = 3,785 l).</Formula>
      <Azzera onClick={azzera}/>
    </div>
  );
}
